export default {
getNowTime(shijian) {
        let date = new Date(shijian)
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        var second = date.getSeconds();
        second = second < 10 ? ('0' + second) : second;
        // return y + '-' + m + '-' + d + ' ';
        // if(h=='00' && minute=='00' && second=='00'){
        //     return y + '-' + m + '-' + d;
        // }else if(minute=='00' && second=='00'){
        //     return y + '-' + m + '-' + d + ' ' + h + ':' + minute;
        // }else{
        //     return y + '-' + m + '-' + d + ' ' + h + ':' + minute+ ':' + second;
        // }
        return y + '.' + m + '.' + d + ' ' + h + ':' + minute;
    },
	
	getNowTimes(shijian) {
	        let date = new Date(shijian)
	        var y = date.getFullYear();
	        var m = date.getMonth() + 1;
	        m = m < 10 ? ('0' + m) : m;
	        var d = date.getDate();
	        d = d < 10 ? ('0' + d) : d;
	        var h = date.getHours();
	        h = h < 10 ? ('0' + h) : h;
	        var minute = date.getMinutes();
	        minute = minute < 10 ? ('0' + minute) : minute;
	        var second = date.getSeconds();
	        second = second < 10 ? ('0' + second) : second;
	        return m + '.' + d + ' ' + h + ':' + minute;
	    },
    /**
     * 深拷贝json对象
     * @param {JSON} obj
     * @returns {string}
     */
    copyArray(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
}
